import React from "react";
import PropTypes from 'prop-types';
import TextField from "../textField/TextField";

const TextAreaField = ({
    ...props
}) => {
    return (
        <TextField
            {...props}
            multiline={true}
        />
    );
};

TextAreaField.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    handleFieldChange: PropTypes.func.isRequired,
    handleFieldBlur: PropTypes.func,
    error: PropTypes.string,
    themeName: PropTypes.string
};

export default TextAreaField;